<app-header></app-header>
<section class="inerpages-banner">
  <img src="assets/img/productpage-bg.jpg" class="w-100" alt="" />
  <div class="fade-bg"></div>
  <div class="mask-content-v-center text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="tbox-iner text-center animate" data-anim-type="zoomIn">
            <div class="heading-iner">
              <h2>{{ "product_list.search" | translate }}</h2>
              <hr />
              <p>{{ "product_list.s_res" | translate }}: "{{ searchprm }}"</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="order-online">
  <div class="container-fluid">
    <div class="row discover_products">
      <div class="heading_secs col-sm-5 col-md-3">
        <div class="row">
          <div class="col-md-12 heading">
            <h4>{{ "product_list.menu" | translate }}</h4>
          </div>
        </div>

        <div class="row">
          <div class="scroll-cate d-md-none">
            <div class="menu_box" *ngFor="let ct of cats">
              <div class="card h-100">
                <a
                  [routerLink]="['/order-online/cats/', ct.cslug]"
                  *ngIf="!ct.hasSubcat"
                >
                  <img
                    class="img-fluid w-100"
                    src="{{ imgurl }}{{ ct.cimage }}"
                    alt="{{ ct.cname }}"
                  />
                  <div class="card-body align-items-center">
                    <p *ngIf="showLang == 'en'" class="card-text">
                      {{ ct.cname }}
                    </p>
                    <p *ngIf="showLang == 'ar'" class="card-text">
                      {{ ct.cname_ar }}
                    </p>
                  </div>
                </a>

                <a
                  [routerLink]="['/order-online/subcats/', ct.cslug]"
                  *ngIf="ct.hasSubcat"
                >
                  <img
                    class="img-fluid w-100"
                    src="{{ imgurl }}{{ ct.cimage }}"
                    alt="{{ ct.cname }}"
                  />
                  <div class="card-body align-items-center">
                    <p *ngIf="showLang == 'en'" class="card-text">
                      {{ ct.cname }}
                    </p>
                    <p *ngIf="showLang == 'ar'" class="card-text">
                      {{ ct.cname_ar }}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="row d-md-flex d-none">
          <div class="col-md-6 col-6 menu_box" *ngFor="let ct of cats">
            <div class="card h-100">
              <a
                [routerLink]="['/order-online/cats/', ct.cslug]"
                *ngIf="!ct.hasSubcat"
              >
                <img
                  class="img-fluid w-100"
                  src="{{ imgurl }}{{ ct.cimage }}"
                  alt="{{ ct.cname }}"
                />
                <div class="card-body align-items-center">
                  <p *ngIf="showLang == 'en'" class="card-text">
                    {{ ct.cname }}
                  </p>
                  <p *ngIf="showLang == 'ar'" class="card-text">
                    {{ ct.cname_ar }}
                  </p>
                </div>
              </a>

              <a
                [routerLink]="['/order-online/subcats/', ct.cslug]"
                *ngIf="ct.hasSubcat"
              >
                <img
                  class="img-fluid w-100"
                  src="{{ imgurl }}{{ ct.cimage }}"
                  alt="{{ ct.cname }}"
                />
                <div class="card-body align-items-center">
                  <p *ngIf="showLang == 'en'" class="card-text">
                    {{ ct.cname }}
                  </p>
                  <p *ngIf="showLang == 'ar'" class="card-text">
                    {{ ct.cname_ar }}
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="media-body products_secs col-sm-7 col-md-9">
        <h2 class="main-heading">{{ catName }}</h2>

        <div
          class="col-lg-3 product_box col-md-6 mb-3"
          *ngFor="let plst of prdlist"
        >
          <div class="card h-100">
            <a
              data-toggle="tooltip"
              data-placement="top"
              title="Add to Favourites"
              href="javacript:void(0)"
              (click)="addtoWishlist(plst.id)"
            >
              <span
                class="fa fa-heart heart-icon"
                *ngIf="plst.wishListid == null"
              ></span>
              <span
                class="fa fa-heart heart-icon red"
                *ngIf="plst.wishListid != null || rpId == plst.id"
              ></span>
            </a>
            <a [routerLink]="['/product', plst.pslug, plst.slug]">
              <img class="card-img-top" src="{{ imgurl }}{{ plst.image }}" />
            </a>
            <div class="card-body">
              <h4 class="card-title mb-1">
                <a
                  [routerLink]="['/product', plst.pslug, plst.slug]"
                  *ngIf="showLang == 'en'"
                  >{{ plst.name }}</a
                >
                <a
                  [routerLink]="['/product', plst.pslug, plst.slug]"
                  *ngIf="showLang == 'ar'"
                  >{{ plst.name_ar }}</a
                >
              </h4>
              <p class="card-text" *ngIf="showLang == 'en'">
                {{ plst.description }}
              </p>
              <p class="card-text" *ngIf="showLang == 'ar'">
                {{ plst.description_ar }}
              </p>
              <h5>{{ plst.currency }} {{ plst.price }}</h5>
            </div>
            <div class="card-footer">
              <a
                [routerLink]="['/product', plst.pslug, plst.slug]"
                class="customize btn"
                [ngStyle]="{
                  width:
                    plst.out_stock == 0 && (plst.isFeast == 0 || plst.isFeast == null ) && plst.isRestricted == null ? '55%' : '100%'
                }"
                >{{ "product_list.customize" | translate }}</a
              >
              <button
                *ngIf="plst.out_stock == 0 && (plst.isFeast == 0 || plst.isFeast == null) && plst.isRestricted == null"
                class="btn addcart"
                (click)="
                  addtoCart(
                    plst.name,
                    plst.id,
                    plst.price,
                    plst.price,
                    1,
                    plst.image,
                    plst.pslug,
                    plst.slug,
                    plst.name_ar,
                    plst.parentcatId,
                    plst.pQty
                  )
                "
              >
                <i class="fab fa-opencart"></i>
                {{ "product_list.add" | translate }}
              </button>
            </div>
            <p *ngIf="plst.out_stock == 1" class="out-stock">
              {{ "cart.out_stock" | translate }}
            </p>
          </div>
        </div>

        <div
          class="col-lg-12 product_box col-md-12 text-center mb-3"
          *ngIf="isprodblank"
        >
          <h1 class="norecods"></h1>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <button
    type="button"
    [hidden]="true"
    class="btn btn-primary btn-sm"
    data-toggle="modal"
    data-target="#modalPopup"
    #cmodel
  ></button>
  <div
    class="modal alert-modal fade"
    id="modalPopup"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          #closeBtn
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body text-center">
          <p *ngIf="showLang == 'en'">{{ cartMsg }}</p>
          <p *ngIf="showLang == 'ar'">{{ cartMsg_ar }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- modelto open -->
<button
  type="button"
  [hidden]="true"
  class="btn btn-primary btn-sm"
  data-toggle="modal"
  data-target="#modalPopup"
  #cmodel
></button>

<!-- Modal -->
<div
  class="modal alert-modal fade"
  id="modalPopup"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body text-center">
        <p *ngIf="showLang == 'en'">{{ cartMsg }}</p>
        <p *ngIf="showLang == 'ar'">{{ cartMsg_ar }}</p>
      </div>
    </div>
  </div>
</div>
